module.exports = __webpack_public_path__ + "static/img/bg-fr.1d6b4df0.png";